import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import LoadingSpinner from "@components/loading-spinner/LoadingSpinner";

import ErrorFallbackComponent from "./ErrorFallbackComponent";

const LazyLoadable = (Component) => (props) =>
(
  <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
    <Suspense fallback={<LoadingSpinner />}>
      <Component {...props} />
    </Suspense>
  </ErrorBoundary>
);

export default LazyLoadable;
